<template>
    <v-container fluid class="bg-grey-darken-4">
        <v-container class="text-center">
            <v-row no-gutters align="start" class="text-start text-small" v-if="pages">
                <v-col v-for="item in pages" class="mb-1" cols="12" md="6" lg="4" :key="item.id">
                   
                        <v-btn
                        :title="simplifyTitle(item.title)"
                        :to="item.route" 
                        
                        variant="plain"
                        class="text-start w-100 text-white btn-primelinks h-auto justify-content-start"
                        >
                        {{ simplifyTitle(item.title) }}
                        </v-btn>
                    
                </v-col>
                <v-col v-if="meta" cols="12">
                    <v-container v-if="meta.last_page > 1">
                        <v-pagination
                            size="x-small"
                            total-visible="6"
                            v-model="meta.current_page"
                            :length="meta.last_page"
                            @update:model-value="getList"
                            rounded="0"
                        ></v-pagination>
                        <p class="text-center">
                            {{ meta.from }} - {{ meta.to }} di {{ meta.total }}
                        </p>
                    </v-container>
                </v-col>
            </v-row>
        </v-container>
    </v-container>
</template>

<script>
import {mapGetters} from "vuex";
export default{
    computed: {
        ...mapGetters({
            loading: 'loading/loading',
            page: 'pages/single',
            pages: 'pages/list',
            meta: 'pages/meta',
            adminPage: 'AdminPages/single',
        }),
    },
    props:{
        data:{
            required: true,
            type: Object,
        }
    },
    data: () => ({
        current_page: null,
    }),
    mounted(){
        this.current_page = (this.page) ? this.page : this.adminPage;
        this.getList()
    },
    methods:{
        simplifyTitle(text){
            text = text.replace('| Primerentcar','');
            text = text.replace('| Primerent','');
            text = text.replace('Exclusive car Hire','');
            text = text.replace(':','');
            text = text.replace('richiedi un preventivo','');
            return text;
        },
        async getList(){

            let where = {
                        'type': 'or',
                        'column': 'parent_id',
                        'is': '=',
                        'value': this.current_page.parent.id
                    }

            if(this.current_page.category_seo){
                where = {
                        'type': 'and',
                        'column': 'category_seo',
                        'is': '=',
                        'value': this.current_page.category_seo,
                    }
            }

            let filters = {
                items_per_page: 24,
                wheres : [
                    where
               ]
            }
            
            this.$store.dispatch('pages/setFilters',filters)
            await this.$store.dispatch('pages/getListLight')
        }
    }
}
</script>